import { op, operatorSymbolString, SympyBuildError } from "./shared";

import type { SympyBuilder } from "./SympyBuilder";
import type { SemanticExpr } from "../types";
import type { NodeJsonMap } from "@corca/data";

export function parseLimit(builder: SympyBuilder, node: NodeJsonMap["function"]): SemanticExpr {
  const limitPointJson = node.children
    .find((n) => n.type === "symbol")
    ?.children.find((n) => n.type === "label" && n.props.position === "right-bottom");
  const pointInline = limitPointJson?.children.find((n) => n.type === "inline");
  if (!pointInline) {
    throw new SympyBuildError(`Unsupported limit point: ${JSON.stringify(node)}`);
  }

  // The bottom label reads "var → point"
  const arrowIdx = pointInline.children.findIndex(
    (c) => c.type === "operatorSymbol" && operatorSymbolString(c) === "→",
  );
  if (arrowIdx === -1) {
    throw new SympyBuildError(
      `Invalid limit point format (missing →): ${JSON.stringify(pointInline)}`,
    );
  }
  const varExpr = builder.traverseNode(
    { type: "inline", props: {}, children: pointInline.children.slice(0, arrowIdx) },
    2,
  );
  const pointExpr = builder.traverseNode(
    { type: "inline", props: {}, children: pointInline.children.slice(arrowIdx + 1) },
    2,
  );

  const bodyInline = node.children.find((n) => n.type === "inline");
  if (!bodyInline) {
    throw new SympyBuildError(`Empty limit arguments`);
  }
  const bodyExpr = builder.traverseNode(bodyInline, 1);

  if (varExpr === null || pointExpr === null || bodyExpr === null) {
    throw new SympyBuildError("Limit is missing its variable, point or body");
  }

  return op("Limit", [bodyExpr, varExpr, pointExpr]);
}
